import type { SyncMetadata, SyncRecord } from './safe-sync';
export const SYNC_STATUS_KEY='yumnote.sync.last-success.v1';
export const SYNC_STATUS_EVENT='yumnote:sync-status';
export function recordsAreSettled(owner:string, meta:SyncMetadata | null, local:SyncRecord[]):boolean {
  if(!meta || meta.owner!==owner || meta.pending)return false;
  const current=new Map(local.map(item=>[JSON.stringify([item.type,item.id]),item.value]));
  if(current.size!==local.length)return false;
  for(const [key,value] of current) if(!Object.hasOwn(meta.records,key) || meta.records[key]?.value!==value)return false;
  for(const [key,entry] of Object.entries(meta.records)) if((current.get(key) ?? null)!==entry.value)return false;
  return true;
}
export function readLastSuccessfulSync(owner:string | null):number | null {
  if(!owner)return null;
  try {const data:unknown=JSON.parse(localStorage.getItem(SYNC_STATUS_KEY) ?? 'null');if(!data || typeof data!=='object' || !('owner' in data) || data.owner!==owner || !('at' in data) || typeof data.at!=='number' || !Number.isFinite(data.at) || data.at<=0 || data.at>Date.now()+60000)return null;return data.at;}catch{return null;}
}
export function recordSuccessfulSync(owner:string, at=Date.now()):void {
  try {localStorage.setItem(SYNC_STATUS_KEY,JSON.stringify({owner,at}));if(typeof window!=='undefined')window.dispatchEvent(new Event(SYNC_STATUS_EVENT));}catch { /* Status cannot make a successful data operation fail. */ }
}
